import { createApp } from 'vue';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import { RoutesServedIndex } from '../views';
import i18n from '../i18n';
import routesServedConfig from './RoutesServedConfig';

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

createApp(RoutesServedIndex, routesServedConfig)
  .use(pinia)
  .use(i18n)
  .mount('#routes-served');
